import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getSatelliteById, getRocketById, getAgencyById } from '../services/dataService';
import { getSatelliteImage } from '../utils/imageUtils';

/**
 * Satellite Details Page Component
 */
const SatelliteDetails = () => {
  const { id } = useParams();
  const satellite = getSatelliteById(id);
  const rocket = satellite ? getRocketById(satellite.rocketId) : null;
  const agency = satellite ? getAgencyById(satellite.agencyId) : null;

  if (!satellite) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>Satellite not found</h2>
        <Link to="/satellites" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to Satellites</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/satellites" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to Satellites
      </Link>

      <div className="card" style={{ marginBottom: '30px' }}>
        <img 
          src={getSatelliteImage(satellite.id, satellite.name)} 
          alt={satellite.name}
          style={{ 
            width: '100%', 
            maxWidth: '800px',
            height: '400px', 
            objectFit: 'cover', 
            borderRadius: '8px', 
            marginBottom: '20px',
            display: 'block',
            margin: '0 auto 20px'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
          {satellite.name}
        </h1>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '20px' }}>
          <div>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Orbital Information</h3>
            <p style={{ marginBottom: '10px' }}><strong>Orbit Type:</strong> {satellite.orbitType}</p>
            <p style={{ marginBottom: '10px' }}><strong>Status:</strong> {satellite.status}</p>
            <p style={{ marginBottom: '10px' }}><strong>Expected Lifespan:</strong> {satellite.expectedLifespan}</p>
          </div>

          <div>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Mission Information</h3>
            <p style={{ marginBottom: '10px' }}><strong>Purpose:</strong> {satellite.purpose}</p>
            <p style={{ marginBottom: '10px' }}><strong>Launch Date:</strong> {satellite.launchDate}</p>
            {rocket && (
              <p style={{ marginBottom: '10px' }}>
                <strong>Launch Vehicle:</strong> <Link to={`/rockets/${rocket.id}`} style={{ color: 'var(--highlight-color)' }}>{rocket.name}</Link>
              </p>
            )}
            {agency && (
              <p style={{ marginBottom: '10px' }}>
                <strong>Agency:</strong> <Link to={`/agencies/${agency.id}`} style={{ color: 'var(--highlight-color)' }}>{agency.name}</Link>
              </p>
            )}
          </div>
        </div>

        <div style={{ marginTop: '20px' }}>
          <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>About {satellite.orbitType} Orbits</h3>
          <p style={{ color: 'var(--text-dark)', lineHeight: '1.8' }}>
            {satellite.orbitType === 'LEO' && 'Low Earth Orbit (LEO) is an orbit around Earth with altitudes between 160 and 2,000 kilometers above sea level.'}
            {satellite.orbitType === 'MEO' && 'Medium Earth Orbit (MEO) is an orbit around Earth with altitudes between 2,000 and 35,786 kilometers.'}
            {satellite.orbitType === 'GEO' && 'Geostationary Orbit (GEO) is a circular orbit 35,786 kilometers above Earth\'s equator, where satellites match Earth\'s rotation.'}
            {satellite.orbitType === 'L2' && 'Lagrange Point L2 is a stable point in space located behind Earth, ideal for space telescopes and observatories.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SatelliteDetails;
